import React, { Component } from 'react';

class ErrorNavigation extends Component {

  handleScrollToElement(id) {
    const element = document.getElementById(id);

    if (element) {
      element.scrollIntoView();
      
      this.props.handleClearActiveErrors();
    }
  }

  componentDidMount() {
    if (this.props.field) {
      this.handleScrollToElement(this.props.field);
    }
  }

  componentDidUpdate(prevProps) {
    if ((this.props.field !== prevProps.field) || (this.props.index !== prevProps.index)) {
      this.handleScrollToElement(this.props.field);
    }
  }

  render() {
    return null;
  }

}

export default ErrorNavigation;
